<div :class="dynamicClass" v-onresize="onResize"><slot/></div>
